module.exports = __webpack_public_path__ + "img/uid-guide1.4533828.jpg";